function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3912 40.2368V43.1492H6.71517L6.69474 40.2368C6.69474 38.148 5.00119 36.4544 2.91214 36.4544L0 36.4341V29.7581H2.91214C8.69953 29.7581 13.3912 34.4495 13.3912 40.2368Z",
  fill: "#49EA83"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.7122 5.95164H43.1517V0H35.7122V5.95164Z",
  fill: "#FFE0CB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.1604 5.95093C29.7168 5.95093 32.5998 8.80999 32.5998 12.3368V24.8604H35.7062V31.2454H28.6375C27.2699 31.2454 26.1613 30.146 26.1613 28.7897C24.9235 30.0664 22.9916 31.2454 19.2772 31.2454C13.2351 31.2454 10.4117 27.4142 10.4117 22.8954C10.4117 18.3768 13.2351 14.546 19.2772 14.546C22.9916 14.546 24.9235 15.6755 26.1613 17.0017V12.3359H13.2846V5.95093H26.1604ZM21.506 20.3418C18.1384 20.3418 16.8506 20.9311 16.8506 22.8954C16.8506 24.8604 18.1384 25.4496 21.506 25.4496C24.8736 25.4496 26.1613 24.8604 26.1613 22.8954C26.1613 20.9311 24.8736 20.3418 21.506 20.3418Z",
  fill: "white"
});

var SvgAgendorLogo = function SvgAgendorLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgendorLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/agendor-logo.10961d06.svg";
export { ForwardRef as ReactComponent };